import { GQL_applicationUserData_currentUser_permissions } from '@/queries/__generated__/applicationUserData';
import Vue from 'vue';

class PermissionService {
  private userPermissions: GQL_applicationUserData_currentUser_permissions | null = null;

  public set(permissions: GQL_applicationUserData_currentUser_permissions): void {
    this.userPermissions = permissions;
  }

  public check(permission: string): boolean {
    if (this.userPermissions) {
      if (Object.keys(this.userPermissions).includes(permission)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (this.userPermissions as any)[permission];
      } else {
        throw new Error(`Permision ${permission} does not exist`);
      }
    } else {
      return false;
    }
  }

  public get isSuperAdmin(): boolean {
    return this.check('isSuperAdmin');
  }

  public reset(): void {
    this.userPermissions = null;
  }
}

export default Vue.observable(new PermissionService());
